// export const environment = {
//     production: true,
//     baseUrl: 'https://dzquba6v9b.execute-api.us-east-2.amazonaws.com/Prod/'
// };

export const environment = window['__env'] || {}; // tslint:disable-line
